export interface SearchableProperty {
    id: string
    label: string
    placeholder: string
    property: string
}

export const SEARCHABLE_PROPERTIES = [
    {
        id: "full_text",
        label: "Full Text Search",
        placeholder: "Search by Full Text",
        property: "full_text"
    },
    {
        id: "name",
        label: "Name Search",
        placeholder: "Search by Name or ID",
        property: "name"
    }
]